export default {
  "content": "<path d=\"M8 10.25a2.5 2.5 0 01-2.5-2.5v-4a2.5 2.5 0 015 0v4a2.5 2.5 0 01-2.5 2.5z\"/><path d=\"M12.5 8.25c0 2.31-1.75 4.22-4 4.47v1.53c0 .28-.22.5-.5.5s-.5-.22-.5-.5v-1.53c-2.25-.25-4-2.16-4-4.47 0-.28.22-.5.5-.5s.5.22.5.5c0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5c0-.28.22-.5.5-.5s.5.22.5.5z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "currentColor",
    "viewBox": "0 0 16 16"
  }
};